import { BETA_FEATURE_DISABLED, BETA_FEATURE_ENABLED } from '~/lib/tracking-events'
import { track } from '~/utils/analytics'
import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { YEAR_IN_SECONDS } from '~/lib/timeInSeconds'
import { FeatureKeyString, features } from '~/lib/beta/features'

const getBetaCookieName = (key: FeatureKeyString) => `BETA_FEATURE_${key}`

export const getFeatures = ({ isEmployee = false }) => {
  return features.filter(feature => isEmployee || !feature.isEmployee)
}

export const toggleFeature = (key: FeatureKeyString) => {
  const BETA_COOKIE_NAME = getBetaCookieName(key)
  const cookie = getCookie(BETA_COOKIE_NAME)

  if (cookie) {
    deleteCookie(BETA_COOKIE_NAME)

    track(BETA_FEATURE_DISABLED, { key })
  } else {
    setCookie(BETA_COOKIE_NAME, 'true', {
      secure: true,
      sameSite: 'lax',
      maxAge: YEAR_IN_SECONDS,
    })

    track(BETA_FEATURE_ENABLED, { key })
  }
}

export const getEnabledFeatures = () => {
  return features
    .filter(({ key }) => Boolean(getCookie(getBetaCookieName(key))))
    .map(feature => feature.key)
}
